import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SectionElement {
    title: string;
    index: number;
}

@Component({
    selector: 'app-anchor-menu',
    templateUrl: './anchor-menu.component.html',
    styleUrl: './anchor-menu.component.css',
    standalone: false,
})
export class AnchorMenuComponent {
    @Input() sectionList: SectionElement[];
    @Input() currentSectionIndex: number;
    @Output() onSelectSection: EventEmitter<number> = new EventEmitter();

    menuOpened: boolean = false;

    selectSection(section: SectionElement) {
        this.onSelectSection.emit(section.index);
    }

    get isMenuOpen() {
        return this.menuOpened;
    }
}
